// extracted by mini-css-extract-plugin
module.exports = {"videoEmbed":"-Q61-","player":"_2PIG2","thumbnail":"_3jdKs","overlay":"_1PhB4","button":"_2iyqq","arrow":"KwkIc","icon":"_2-g5V"};